import { ReactNode, useMemo, useRef } from 'react'
import { ScrollPositionContext, scrollPositionContext, ScrollRoutes } from '.'

export interface ScrollPositionProviderProps {
  children: ReactNode
}

const ScrollPositionProvider = ({ children }: ScrollPositionProviderProps) => {
  const data = useRef<ScrollRoutes>({})

  const value = useMemo<ScrollPositionContext>(
    () => ({
      getData: () => data.current,
      setData(routes) {
        data.current = routes
      },
    }),
    [],
  )

  return (
    <scrollPositionContext.Provider value={value}>
      {children}
    </scrollPositionContext.Provider>
  )
}

export default ScrollPositionProvider
